import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { Grid } from '@material-ui/core'
import { TextArea } from '../../../../../components'

/**
 * Biography
 */
class Biography extends PureComponent {
  /**
   * Render
   * @return {XML}
   */
  render () {
    const { values, onChange } = this.props

    return (
      <Grid item xs={9} container spacing={3}>
        <Grid item xs={12}>
          <div className='section_title'>Biography</div>
        </Grid>

        <Grid item xs={12} container spacing={3}>
          <Grid item xs={8}>
            <TextArea
              id='bio'
              value={values.bio}
              onChange={onChange}
              maxlength={700}
              rows={15} />
          </Grid>
        </Grid>
      </Grid>
    )
  }
}

Biography.propTypes = {
  values: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired
}

export default Biography
